import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  list-style: none;
  padding-bottom: 8px;
  display: flex;
  column-gap: 11px;
  border-bottom: 1px solid #F1F1F1;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

const SubCategoryListItem = styled.div`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  padding-bottom: ${({ theme }) => theme.spacing.xs};
  color: #E1E1E1;

  &.active {
    border-bottom: 1px solid #58c3bb;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    color: #4FADA6;
  }
`;

const SubCategories = ({data, onSubcategoryClickHandler}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [data]);
  return (
    <Wrapper>
      {data.map((category, index) => (
        <SubCategoryListItem
          key={index}
          className={activeIndex === index ? 'active' : ''}
          onClick={() => {
            setActiveIndex(index);
            onSubcategoryClickHandler(category.id);
          }}
        >
          {category.value}
        </SubCategoryListItem>
      ))}
      </Wrapper>
  );
};

export default SubCategories;
